import styled from 'styled-components';


export const AddNewReportBodyCont = styled.div`
  box-sizing: border-box;
  padding: 28px 0 48px 0;
  display: flex;
  justify-content: center;
`;
